import React, { useEffect, useRef, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import styles from './index.module.scss';

type BrandCardProps = {
  name?: string;
};

const BrandCard: React.FC<BrandCardProps> = ({ name }) => {
  const [toolTip, setToolTip] = useState('');
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    ReactTooltip.rebuild();
  }, []);
  useEffect(() => {
    // const { clientWidth, scrollWidth, offsetWidth } = ref.current;
    const { offsetWidth } = ref.current;
    // const rangeWidth = ref.current?.getBoundingClientRect().width;
    if (offsetWidth + 32 > 160) {
      setToolTip(name);
    }
  }, [name]);
  return (
    <>
      <div className={styles.card} data-for="brands" data-tip={toolTip}>
        <span ref={ref}> {name}</span>
      </div>
    </>
  );
};
export default BrandCard;
